import React, { useRef, useState, useEffect } from 'react'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import Picker from 'emoji-picker-react'
import useOnClickOutside from 'srcReact/helpers/hooks/useOnClickOutside'
import { useTranslation } from 'react-i18next'
import { isMobileScreen } from 'srcReact/helpers/utils'
import MobileModal from '../MobileModal'
import EmojiPickerButton from './EmojiPickerButton'

export default function EmojiPicker({
  containerCss,
  pickerContainerCSS,
  emojiButtonCSS,
  appendEmoji,
  iconName,
  iconStyle,
  handleOpenPicker
}) {
  const [showPicker, setShowPicker] = useState(false)
  const { t } = useTranslation()
  const emojiRef = useRef()

  useEffect(() => {
    if (handleOpenPicker) {
      handleOpenPicker(showPicker)
    }
  }, [showPicker])

  const onEmojiClick = (event, emojiObject) => {
    event.preventDefault()
    appendEmoji(emojiObject)
    closePicker()
  }

  const displayPicker = (e) => {
    e.stopPropagation()
    setShowPicker(!showPicker)
  }
  const closePicker = () => {
    setShowPicker(false)
  }

  useOnClickOutside(emojiRef, closePicker, isMobileScreen())

  return (
    <div ref={emojiRef} className={`${styles.container} ${containerCss}`}>
      <EmojiPickerButton
        ariaLabel={t('messenger.selectEmoji')}
        className={`${styles.emojiButton} ${emojiButtonCSS}`}
        displayPicker={displayPicker}
        renderEmojiIcon={() => (
          <Icon name={iconName || 'smiley-glad'} styleModifier={`${styles.gladIcon} ${iconStyle}`} />
        )}
      />

      {showPicker &&
        (isMobileScreen() ? (
          <MobileModal
            closeOnDocumentClick={true}
            isOpen={showPicker}
            handleClose={closePicker}
            className={`${styles.pickerContainer} ${pickerContainerCSS}`}>
            <Picker native={true} onEmojiClick={onEmojiClick} disableAutoFocus={false} />
          </MobileModal>
        ) : (
          <div className={`${styles.pickerContainer} ${pickerContainerCSS}`}>
            <Picker native={true} onEmojiClick={onEmojiClick} disableAutoFocus={false} />
          </div>
        ))}
    </div>
  )
}
